import { Box, Typography } from "@mui/material"
import { numberFormat } from "../../../utils/nunberFormat"
import { useTranslation } from "react-i18next"

interface Props {
    BgColor: string
    FontColor: string
    title: string
    loading: boolean
    countNumber: number
}

const StatusComponents = ({ BgColor, FontColor, loading, countNumber, title }: Props) => {
    const { t } = useTranslation('global');
    return (
        <Box sx={{
            backgroundColor: BgColor, borderRadius: '16px', p: 4, boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
        }}>
            <Box>
                <Typography color={FontColor} sx={{ mb: 1 }}>{title}</Typography>
                <Typography color={FontColor} fontWeight="bold" fontSize={32}>
                    {
                        loading ? "Loading..." : <>{numberFormat(countNumber)} {t("customer_page.users")}</>
                    }
                </Typography>
            </Box>
        </Box>
    )
}
export default StatusComponents